interface IComponentIsVisibleProps {
  children: React.ReactNode;
  when: boolean;
}

export function ComponentIsVisible({ children, when }: IComponentIsVisibleProps): JSX.Element {
  return <>{when && children}</>;
}
